import {
  CustomerPermission,
  DeliveryNotesPermission,
  DualLangInspectionsPermission,
  EmployeePermission,
  MaterialInventoriesPermission,
  MaterialPermission,
  PackingNotesPermission,
  PaperMaterialInventoriesPermission,
  PaperMaterialsPermission,
  ProductInventoryPermission,
  ProductPermission,
  PurchaseOrdersPermission,
  QuotationsPermission,
  RolePermission,
  StellaInspectionsPermission,
  UserPermission,
  WorkOrdersPermission,
} from "commons/enum/permission";
import { CustomerDetail } from "pages/customer/customer-detail/customer-detail";
import { CustomerList } from "pages/customer/customer-list/customer-list";
import { DeliveryNote } from "pages/delivery-note/delivery-note";
import { DeliveryNoteDetail } from "pages/delivery-note/delivery-note-detail/delivery-note-detail";
import { DeliveryNoteList } from "pages/delivery-note/delivery-note-list/delivery-note-list";
import { DualLangInspectionNoteDetail } from "pages/dual-lang-inspection-note/detail/detail";
import { Employee } from "pages/employee/employee";
import { EmployeeDetail } from "pages/employee/employee-detail/employee-detail";
import { EmployeeList } from "pages/employee/employee-list/employee-list";
import { HomeBoard } from "pages/home/home-board/home-board";
import {
  PermissionProtect,
  PermissionProtectIndex,
} from "pages/login/permisson-protect";
import {
  MaterialInventory,
  MaterialInventoryHome,
} from "pages/material-inventory/material-inventory";
import { OAuthRedirect } from "pages/oauth/oauth-redirect";
import { Order } from "pages/order/order";
import { OrderDetail } from "pages/order/order-detail/order-detail";
import { OrderList } from "pages/order/order-list/order-list";
import { PackingNote } from "pages/packing-note/packing-note";
import { PackingNoteDetail } from "pages/packing-note/packing-note-detail/packing-note-detail";
import { PackingNoteList } from "pages/packing-note/packing-note-list/packing-note-list";
import {
  PaperInventory,
  PaperInventoryHome,
} from "pages/paper-inventory/paper-inventory";
import {
  ProductInventory,
  ProductInventoryHome,
} from "pages/product-inventory/product-inventory";
import { Product } from "pages/product/product";
import { ProductDetail } from "pages/product/product-detail/product-detail";
import { ProductList } from "pages/product/product-list/product-list";
import { Quotation } from "pages/quotation/quotation";
import { QuotationDetail } from "pages/quotation/quotation-detail/quotation-detail";
import { QuotationList } from "pages/quotation/quotation-list/quotation-list";
import { RoleAndPermission } from "pages/setting/role-and-permision/role-and-permission";
import { StellaInspectionNoteDetail } from "pages/stella-inspection-note/inspection-note-detail/inspection-note-detail";

import { InspectionNote } from "pages/inspection-note/inspection-note";
import { InspectionNoteList } from "pages/inspection-note/list/inspection-note-list";
import { WorkOrderPo } from "pages/work-order-po/work-order-po";
import { WorkOrderPoDetail } from "pages/work-order-po/work-order-po-detail/work-order-po-detail";
import { WorkOrderPoList } from "pages/work-order-po/work-order-po-list/work-order-po-list";
import { WorkOrder } from "pages/work-order/work-order";
import { WorkOrderDetail } from "pages/work-order/work-order-detail/work-order-detail";
import { WorkOrderList } from "pages/work-order/work-order-list/work-order-list";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import { Customer } from "../pages/customer/customer";
import ErrorPage from "../pages/errors/error";
import { NotFoundPage } from "../pages/errors/not-found-page";
import { HomePage } from "../pages/home/home";
import { AuthProtect } from "../pages/login/auth-protect";
import { LoginPage } from "../pages/login/login";
import { Setting } from "../pages/setting/setting";
import { User } from "../pages/setting/user/user";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<ErrorPage />}>
      <Route
        path="/"
        element={
          <AuthProtect>
            <HomePage />
          </AuthProtect>
        }
      >
        <Route index element={<HomeBoard></HomeBoard>}></Route>

        <Route
          path="/setting"
          element={
            <PermissionProtect
              accessPermissions={[UserPermission.Access, RolePermission.Access]}
            >
              <Setting></Setting>
            </PermissionProtect>
          }
        >
          <Route
            index
            element={
              <PermissionProtectIndex
                accessPermissions={[
                  UserPermission.Access,
                  RolePermission.Access,
                ]}
              >
                {(accessKey) => {
                  return accessKey === UserPermission.Access ? (
                    <Navigate to="users" replace />
                  ) : accessKey === RolePermission.Access ? (
                    <Navigate to="role-and-permission" replace />
                  ) : (
                    <></>
                  );
                }}
              </PermissionProtectIndex>
            }
          ></Route>
          <Route
            path="users"
            element={
              <PermissionProtect accessPermissions={[UserPermission.Access]}>
                <User></User>
              </PermissionProtect>
            }
          ></Route>
          <Route
            path="role-and-permission"
            element={
              <PermissionProtect accessPermissions={[RolePermission.Access]}>
                <RoleAndPermission></RoleAndPermission>
              </PermissionProtect>
            }
          ></Route>
        </Route>

        <Route
          path="/customers"
          element={
            <PermissionProtect accessPermissions={[CustomerPermission.Default]}>
              <Customer></Customer>
            </PermissionProtect>
          }
        >
          <Route index element={<CustomerList></CustomerList>}></Route>
          <Route
            path=":customerId"
            element={<CustomerDetail></CustomerDetail>}
          ></Route>
        </Route>

        <Route
          path="/products"
          element={
            <PermissionProtect accessPermissions={[ProductPermission.Default]}>
              <Product></Product>
            </PermissionProtect>
          }
        >
          <Route path="" element={<ProductList></ProductList>}></Route>
          <Route
            path=":productId"
            element={<ProductDetail></ProductDetail>}
          ></Route>
        </Route>

        <Route
          path="/orders"
          element={
            <PermissionProtect
              accessPermissions={[PurchaseOrdersPermission.Default]}
            >
              <Order></Order>
            </PermissionProtect>
          }
        >
          <Route index element={<OrderList></OrderList>}></Route>
          <Route path=":orderId" element={<OrderDetail></OrderDetail>}></Route>
        </Route>

        <Route
          path="/products-inventory"
          element={
            <PermissionProtect
              accessPermissions={[
                ProductInventoryPermission.Default,
                ProductInventoryPermission.Export,
                ProductInventoryPermission.Import,
              ]}
            >
              <ProductInventory></ProductInventory>
            </PermissionProtect>
          }
        >
          <Route
            index
            element={<ProductInventoryHome></ProductInventoryHome>}
          ></Route>
        </Route>

        <Route
          path="/papers-inventory"
          element={
            <PermissionProtect
              accessPermissions={[
                PaperMaterialsPermission.Default,
                PaperMaterialInventoriesPermission.Default,
                PaperMaterialInventoriesPermission.Issue,
                PaperMaterialInventoriesPermission.Receipt,
              ]}
            >
              <PaperInventory></PaperInventory>
            </PermissionProtect>
          }
        >
          <Route
            index
            element={<PaperInventoryHome></PaperInventoryHome>}
          ></Route>
        </Route>

        <Route
          path="/materials-inventory"
          element={
            <PermissionProtect
              accessPermissions={[
                MaterialPermission.Default,
                MaterialInventoriesPermission.Default,
                MaterialInventoriesPermission.Issue,
                MaterialInventoriesPermission.Receipt,
              ]}
            >
              <MaterialInventory></MaterialInventory>
            </PermissionProtect>
          }
        >
          <Route
            index
            element={<MaterialInventoryHome></MaterialInventoryHome>}
          ></Route>
        </Route>

        <Route
          path="/work-orders"
          element={
            <PermissionProtect
              accessPermissions={[WorkOrdersPermission.Default]}
            >
              <WorkOrder></WorkOrder>
            </PermissionProtect>
          }
        >
          <Route index element={<WorkOrderList></WorkOrderList>}></Route>
          <Route
            path=":workOrderId"
            element={<WorkOrderDetail></WorkOrderDetail>}
          ></Route>
        </Route>

        <Route
          path="/work-orders-po"
          element={
            <PermissionProtect
              accessPermissions={[WorkOrdersPermission.Default]}
            >
              <WorkOrderPo></WorkOrderPo>
            </PermissionProtect>
          }
        >
          <Route index element={<WorkOrderPoList></WorkOrderPoList>}></Route>
          <Route
            path=":workOrderId"
            element={<WorkOrderPoDetail></WorkOrderPoDetail>}
          ></Route>
        </Route>

        <Route
          path="/delivery-notes"
          element={
            <PermissionProtect
              accessPermissions={[DeliveryNotesPermission.Default]}
            >
              <DeliveryNote></DeliveryNote>
            </PermissionProtect>
          }
        >
          <Route index element={<DeliveryNoteList></DeliveryNoteList>}></Route>
          <Route
            path=":deliveryNoteId"
            element={<DeliveryNoteDetail></DeliveryNoteDetail>}
          ></Route>
        </Route>

        <Route
          path="/quotations"
          element={
            <PermissionProtect
              accessPermissions={[QuotationsPermission.Default]}
            >
              <Quotation></Quotation>
            </PermissionProtect>
          }
        >
          <Route index element={<QuotationList></QuotationList>}></Route>
          <Route
            path=":quotationId"
            element={<QuotationDetail></QuotationDetail>}
          ></Route>
        </Route>

        <Route
          path="/packing-notes"
          element={
            <PermissionProtect
              accessPermissions={[PackingNotesPermission.Default]}
            >
              <PackingNote></PackingNote>
            </PermissionProtect>
          }
        >
          <Route index element={<PackingNoteList></PackingNoteList>}></Route>
          <Route
            path=":packingNoteId"
            element={<PackingNoteDetail></PackingNoteDetail>}
          ></Route>
        </Route>

        <Route
          path="/inspection-notes"
          element={
            <PermissionProtect
              accessPermissions={[
                StellaInspectionsPermission.Default,
                DualLangInspectionsPermission.Default,
              ]}
            >
              <InspectionNote></InspectionNote>
            </PermissionProtect>
          }
        >
          <Route
            index
            element={<InspectionNoteList></InspectionNoteList>}
          ></Route>
          <Route
            path="stella/:inspectionNoteId"
            element={<StellaInspectionNoteDetail></StellaInspectionNoteDetail>}
          ></Route>
          <Route
            path="dual-lang/:dualLangInspectionNoteId"
            element={
              <DualLangInspectionNoteDetail></DualLangInspectionNoteDetail>
            }
          ></Route>
        </Route>

        {/* <Route
          path="/dual-lang-inspection-notes"
          element={
            <PermissionProtect
              accessPermissions={[DualLangInspectionsPermission.Default]}
            >
              <DualLangInspectionNote></DualLangInspectionNote>
            </PermissionProtect>
          }
        >
          <Route
            index
            element={<DualLangInspectionNoteList></DualLangInspectionNoteList>}
          ></Route>
          <Route
            path=":dualLangInspectionNoteId"
            element={
              <DualLangInspectionNoteDetail></DualLangInspectionNoteDetail>
            }
          ></Route>
        </Route> */}

        <Route
          path="/employees"
          element={
            <PermissionProtect accessPermissions={[EmployeePermission.Default]}>
              <Employee></Employee>
            </PermissionProtect>
          }
        >
          <Route index element={<EmployeeList></EmployeeList>}></Route>
          <Route
            path=":employeeId"
            element={<EmployeeDetail></EmployeeDetail>}
          ></Route>
        </Route>
        {/* <Route path="/example" element={<Example></Example>}></Route> */}
      </Route>

      <Route path="/login" element={<LoginPage></LoginPage>} />
      <Route path="/oauth/redirect" element={<OAuthRedirect></OAuthRedirect>} />
      <Route path="*" element={<NotFoundPage />}></Route>
    </Route>,
  ),
);
